// src/components/dashboard/experimentalLayout.ts
// Carved from the designer's file of the same path at Ventaje 991a664d (WU-141 S-6): only the two side-vignette washes
// ExperimentalSideVignette.tsx imports, byte for byte. The rest of his file is the app shell's geometry and is not ported.
/** Left-only wash for the leads page (no right fade) */
export const EXP_VIGNETTE_LEFT =
  'linear-gradient(to right, rgba(0,0,0,0.62) 0%, rgba(0,0,0,0.47) 10%, rgba(0,0,0,0.24) 24%, rgba(0,0,0,0.09) 36%, rgba(0,0,0,0.03) 44%, transparent 52%)';

/** Side shade — matches how dark the header looks, stretched inward from both edges */
export const EXP_VIGNETTE =
  'linear-gradient(to right, rgba(0,0,0,0.62) 0%, rgba(0,0,0,0.47) 10%, rgba(0,0,0,0.24) 24%, rgba(0,0,0,0.09) 36%, rgba(0,0,0,0.03) 44%, transparent 50%, rgba(0,0,0,0.03) 56%, rgba(0,0,0,0.09) 64%, rgba(0,0,0,0.24) 76%, rgba(0,0,0,0.47) 90%, rgba(0,0,0,0.62) 100%)';
